export default {
    validate(value) {
        return true;
    }
}
